import { WizCommand } from '@wizeoo/akm-component-lib';
import { WIZ_COMMAND_METHOD} from '@wizeoo/akm-core-lib';
import { User, UserCriteria, UserScenario, UserWrapper } from '@wizeoo/akm-message-lib';
import { Model } from '../../model/model';
import { ExternalAPI } from '../../model/external-api';
import { UserVO } from '../../vo/user/user.vo';

/**
 * Appels user (Find)
 */
export class UserServiceCmd extends WizCommand<UserWrapper> {
  
  protected model: Model = null;

  constructor(model: Model) {
    super();
    this.model = model;
  }

  // mémorisation de la source pour mise à jour sur retour service
  public sourceVO: UserVO = null;
  private method: any;
  
  
  /** retourne le wrapper pré-alimenté */
  public UserWrapper(): UserWrapper {
    const wrapper: UserWrapper = new UserWrapper();
    wrapper.criteria = new UserCriteria();
    wrapper.criteria.manageDeprecated = true;
    wrapper.criteria.manageDeleted = true;
    wrapper.criteria.domain = this.model.domainCode;
    // On prend seulement les users qui ont accés à la BU
    wrapper.criteria.businessUnitCode = this.model.businessUnitCode;
    wrapper.scenario = new UserScenario();
    wrapper.scenario.languageCode = this.model.localeEngine.getLocale();
    return wrapper;
  }


  /**
   * Chargement complet d'un user
   *
   * @param UserVO
   */
  public getUser(user: UserVO, pCallback: (pCmd: UserServiceCmd) => void) {
    const wrapper: UserWrapper = this.UserWrapper();
    wrapper.scenario.manageUserApps = true;
    wrapper.method = WIZ_COMMAND_METHOD.GET;
    wrapper.entity = user.source;
    this.sourceVO = user;
    this.method = WIZ_COMMAND_METHOD.GET;
    this.configureRemote(ExternalAPI.USER, wrapper, pCallback);
    return this;
  }

  /**
   * chargement de tous les users de la BU (AKM)
   * @return UserCmd la commande configuré
   */
  public find(): UserServiceCmd {
    const wrapper: UserWrapper = this.UserWrapper();
    wrapper.method = WIZ_COMMAND_METHOD.FIND;
    this.method = WIZ_COMMAND_METHOD.FIND;
    this.configureRemote(ExternalAPI.USER, wrapper);
    return this;
  }

  /**
   * chargement de tous les users du domaine
   * @return UserCmd la commande configuré
   */
  public findForDom(): UserServiceCmd {
    const wrapper: UserWrapper = this.UserWrapper();
    wrapper.method = WIZ_COMMAND_METHOD.FIND;
    this.method = WIZ_COMMAND_METHOD.FIND;
    wrapper.criteria.domain = this.model.currentDomainCode;
    wrapper.criteria.businessUnitCode = null;
    wrapper.scenario.manageUserApps = true;
    this.configureRemote(ExternalAPI.USER, wrapper);
    return this;
  }

  /**
   * Chargement complet d'un user
   * 
   * @param UserVO 
   */
  public deleteUser(user: UserVO, pCallback: (pCmd: UserServiceCmd) => void) {
    const wrapper: UserWrapper = this.UserWrapper();
    wrapper.scenario.manageUserApps = true;
    wrapper.scenario.manageDomains = true;
    // wrapper.scenario.manageOwnedDomains = true;
    wrapper.method = WIZ_COMMAND_METHOD.DELETE;
    wrapper.entity = user.source;
    // RM166 suppression compte utilisateur dans Keycloak
    wrapper.criteria.domain = Model.getInstance().currentDomainCode.toLowerCase();

    this.sourceVO = user;
    this.method = WIZ_COMMAND_METHOD.DELETE;
    this.configureRemote(ExternalAPI.USER, wrapper, pCallback);
    return this;
  }

  /**
   * modif mdp
   * 
   * @param UserVO 
   */
  public updatePassword(user: UserVO, pCallback?: Function): UserServiceCmd {

    const wrapper: UserWrapper = this.UserWrapper();
    wrapper.method = ExternalAPI.USER_PASSWORD;
    wrapper.entity = {...user.source};
    wrapper.criteria.domain = Model.getInstance().currentDomainCode.toLowerCase();
    this.sourceVO = user;
    this.method = ExternalAPI.USER_PASSWORD;
    this.configureRemote(ExternalAPI.USER, wrapper, pCallback);
    return this;
  }


  /**
   * retour de service
   * gestion de retour selon la méthode d'appelle
   */
  public wizResult(): void {
    super.wizResult();
    const wrapper: UserWrapper = this.result;

    if (this.method === WIZ_COMMAND_METHOD.FIND) {
      this.model.userEngine.feed(wrapper.entities);
    } else if (this.method === WIZ_COMMAND_METHOD.GET) {
      const entity: User = wrapper.entity;
      this.model.userEngine.feed([entity]);
      this.sourceVO.source = entity;
      this.sourceVO.loaded = true;
    } else if (this.method === WIZ_COMMAND_METHOD.DELETE) {
      const vo: UserVO = this.sourceVO;
      this.model.usersMap.delete(vo.mail);
    } else if (this.method === ExternalAPI.USER_PASSWORD) {
      // const entity: User = wrapper.entity;
      // console.log('back from password', entity);
    }
  }
}
